import { gray } from '@kmns-internal/furikake/tokens'
import { Box } from '@mui/material'
import { FC } from 'react'
import { getFormattedRecordedAt } from 'src/exShared/util/date'

type Props = {
  recordedAt?: Date
}

/** セル内で値の下に添える回答日時 */
export const TableSectionRecordedAt: FC<Props> = ({ recordedAt }) => (
  <Box sx={{ fontSize: 12, color: gray[6] }}>
    {getFormattedRecordedAt(recordedAt)}
  </Box>
)
